var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg50KCandidates(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 106,
    viewBox: "0 0 105 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M78.7438 31.825C78.4813 31.7813 78.175 31.7813 77.9125 31.825C71.875 31.6063 67.0625 26.6625 67.0625 20.5375C67.0625 14.2813 72.0938 9.25 78.35 9.25C84.6063 9.25 89.6375 14.325 89.6375 20.5375C89.5938 26.6625 84.7813 31.6063 78.7438 31.825Z",
    stroke: "url(#paint0_linear_762_1559)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M74.2328 63.6759C80.2266 64.6821 86.8328 63.6321 91.4703 60.5259C97.6391 56.4134 97.6391 49.6759 91.4703 45.5634C86.7891 42.4569 80.0953 41.4069 74.1016 42.4569",
    stroke: "url(#paint1_linear_762_1559)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.1047 31.825C26.3672 31.7813 26.6734 31.7813 26.9359 31.825C32.9734 31.6063 37.7859 26.6625 37.7859 20.5375C37.7859 14.2813 32.7547 9.25 26.4984 9.25C20.2422 9.25 15.2109 14.325 15.2109 20.5375C15.2547 26.6625 20.0672 31.6063 26.1047 31.825Z",
    stroke: "url(#paint2_linear_762_1559)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M30.6141 63.6759C24.6203 64.6821 18.0141 63.6321 13.3766 60.5259C7.20781 56.4134 7.20781 49.6759 13.3766 45.5634C18.0578 42.4569 24.7516 41.4069 30.7453 42.4569",
    stroke: "url(#paint3_linear_762_1559)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5017 64.5086C52.2392 64.4648 51.9329 64.4648 51.6704 64.5086C45.6329 64.2898 40.8203 59.3461 40.8203 53.2211C40.8203 46.9648 45.8517 41.9336 52.1079 41.9336C58.3642 41.9336 63.3954 47.0086 63.3954 53.2211C63.3517 59.3461 58.5392 64.3336 52.5017 64.5086Z",
    stroke: "url(#paint4_linear_762_1559)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.775 78.2906C33.6062 82.4031 33.6062 89.1402 39.775 93.2527C46.775 97.9339 58.2375 97.9339 65.2375 93.2527C71.4063 89.1402 71.4063 82.4031 65.2375 78.2906C58.2813 73.6531 46.775 73.6531 39.775 78.2906Z",
    stroke: "url(#paint5_linear_762_1559)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_762_1559",
    x1: 78.35,
    y1: 9.25,
    x2: 78.35,
    y2: 31.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2853D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2853D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_762_1559",
    x1: 85.0992,
    y1: 42.0625,
    x2: 85.0992,
    y2: 64.0452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2853D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2853D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_762_1559",
    x1: 26.4984,
    y1: 9.25,
    x2: 26.4984,
    y2: 31.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2853D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2853D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_762_1559",
    x1: 19.7477,
    y1: 42.0625,
    x2: 19.7477,
    y2: 64.0452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2853D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2853D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_762_1559",
    x1: 52.1079,
    y1: 41.9336,
    x2: 52.1079,
    y2: 64.5086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2853D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2853D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_762_1559",
    x1: 52.5063,
    y1: 74.8125,
    x2: 52.5063,
    y2: 96.7636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2853D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2853D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg50KCandidates);
export default __webpack_public_path__ + "static/media/50k+Candidates.ce776ca35e7949b3a9be33ceac15af1d.svg";
export { ForwardRef as ReactComponent };